<template>
  <b-modal
    :id="modalName"
    :size="sizeModal"
    :stacked="stacked"
    hide-footer
    hide-header
    centered
    title="Emitir"
    @hide="closeModal"
  >
    <div>
      <div
        :class="`headerModal`"
        :style="`background-color: ${
          typeModal === 'danger'
            ? 'brown'
            : typeModal === 'warning'
            ? '#da8900'
            : typeModal === 'info'
            ? 'oklch(54.6% 0.245 262.881)'
            : typeModal === 'success'
            ? '#006256'
            : 'gray'
        }`"
      >
        <div
          style="
            display: flex;
            align-items: center;
            gap: 1rem;
            position: relative;
          "
        >
          <div class="contentIconHeader">
            <component
              v-if="headerIcon"
              :is="headerIcon"
              style="width: 20px; height: 20px; color: white"
            />
          </div>

          <div>
            <h6 class="titleModal">{{ title }}</h6>

            <p
              v-if="subtitle"
              style="
                margin: 0.3rem 0 0 0;
                color: #ffffffde;
                font-size: 0.8rem;
                font-weight: 500;
              "
            >
              {{ subtitle }}
            </p>
          </div>

          <div style="width: 30px; height: 30px">
            <div class="contentCloseIcon" @click="$bvModal.hide(modalName)">
              <b-icon-x-lg style="width: 12px; height: 12px; color: white" />
            </div>
          </div>
        </div>
      </div>

      <div class="bodyModal" v-if="$slots.default">
        <slot></slot>
      </div>

      <div v-if="showLeftButton || showRightButton" class="btnModal">
        <div
          class="btnActionModal"
          @click="handleLeftButton"
          v-if="showLeftButton"
        >
          {{ leftButtonText }}
        </div>
        <div
          :class="`btnActionModal btnDefault ${typeModal}`"
          @click="handleRightButton"
          v-if="showRightButton"
        >
          {{ rightButtonText }}
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import print from "../../reports/sale";

export default {
  props: {
    typeModal: {
      typeof: String,
      default: "danger",
    },
    saleId: {
      typeof: String,
    },
    modalName: {
      typeof: String,
      default: "modal-confirm",
    },
    title: {
      typeof: String,
      default: "Informe um título",
    },
    subtitle: {
      typeof: String,
      default: "Informe um subtitulo",
    },
    rightButtonText: {
      type: String,
      default: "Sim, excluir",
    },
    rightButtonClick: {
      type: Function,
      default: () => null,
    },
    leftButtonText: {
      type: String,
      default: "Não, manter",
    },
    leftButtonClick: {
      type: Function,
      default: () => null,
    },
    headerIcon: {
      type: String,
      default: "b-icon-trash",
    },
    showLeftButton: {
      type: Boolean,
      default: true,
    },
    showRightButton: {
      type: Boolean,
      default: true,
    },
    sizeModal: {
      type: String,
      default: "md",
    },
    stacked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    printReportSelect() {
      if (!this.saleId) return;

      print("receiptStandard", this.saleId);
    },
    closeModal() {
      this.$emit("modalClosed");
      this.$bvModal.hide(this.modalName);
    },
    handleLeftButton() {
      if (this.leftButtonClick) this.leftButtonClick();
      this.closeModal();
    },
    handleRightButton() {
      if (this.rightButtonClick) this.rightButtonClick();
      this.closeModal();
    },
  },
  computed: {
    ...mapState({}),
  },
};
</script>

<style scoped>
.titleModal {
  font-size: 1.2rem;
  color: white;
  font-weight: 500;
  margin: 0;
}

/* MODAL STYLE */

::v-deep(.modal-body) {
  padding: 0;
}

::v-deep(.modal-content) {
  border-radius: 0.625rem;
}

.headerModal {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.2rem;
  border-radius: 0.5rem 0.5rem 0 0;
}

.contentCloseIcon {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 255 255 / 17%);
  border-radius: 50%;
  position: absolute;
  right: -10px;
  top: -10px;
  cursor: pointer;
  transition: ease-in all 0.1s;
}

.contentCloseIcon:hover {
  background-color: rgba(255, 255, 255, 0.376);
  transition: ease-in all 0.1s;
}

.btnModal {
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: space-around;
  padding: 1rem 1.2rem;
  border-top: solid 1px rgba(128, 128, 128, 0.15);
}

.btnActionModal {
  flex: 1 1 auto;
  outline: none;
  border: none;
  border-radius: 5px;
  box-shadow: 0 0 2px 1px rgba(128, 128, 128, 0.248);
  transition: ease-in all 0.1s;
  display: flex;
  justify-content: center;
  padding: 0.8rem 1.2rem;
  font-size: 0.775rem;
  cursor: pointer;
  border: solid 1px rgba(0, 0, 0, 0.171);
}

.btnActionModal:hover {
  transition: ease-in all 0.1s;
  background-color: rgba(132, 157, 140, 0.096);
}

.btnDefault {
  color: white;
  flex: 0 1 auto;
  color: white;
  min-width: 100px;
}

.info {
  background-color: oklch(54.6% 0.245 262.881);
}

.info:hover {
  background-color: oklch(0.49 0.22 262.91);
  color: white;
}

.success {
  background-color: #006256;
}

.success:hover {
  background-color: #005349;
  color: white;
}

.warning {
  background-color: #da8900;
}

.warning:hover {
  background-color: #ce8200;
  color: white;
}

.danger {
  background-color: brown;
}

.danger:hover {
  background-color: rgb(146, 38, 38);
  color: white;
}

.contentIconHeader {
  min-width: 40px;
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 255 255 / 17%);
  border-radius: 8px;
}
</style>
